'use strict'

jQuery( document ).ready( function ( $ ) {
	if ( $( '.twitter__widget__carousel' ) ) {
		const owlTwitterWidget = $( '.twitter__widget__carousel' )

		// Checking for twitter carousels existence
		if ( owlTwitterWidget.length ) {
			owlTwitterWidget.owlCarousel( {
				'loop': true,
				'items': 1,
				'autoplay': true,
				'autoplayTimeout': 8000,
				responsiveClass: true,
				margin: 20,
				navText: [ "<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>" ],
			} )
		}
	}
} )
